// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"235":"d5bd61a6","697":"df89b80b","715":"a916827b","776":"8df01ee1","879":"dab0d5b5","914":"041d1078"}[chunkId] + ".chunk.css";
};